import _ from 'lodash';
import { PRIORITIES } from 'constants/serendipity';
import * as ACTION_TYPE from './types';

const INITIAL_STATE = {
  preferences: [],
  actionInContext: null,
  actionInContextPriority: PRIORITIES.LOW,
  history: [],
};

const changeItemStatus = (elementType, elementId, status, prevState) => {
  const state = { ...prevState };
  const { preferences } = state;
  const index = _.findIndex(preferences, { element_type: elementType, element_id: elementId });
  if (index >= 0) {
    preferences[index].enabled = status;
  } else {
    const item = {
      element_type: elementType,
      element_id: elementId,
      enabled: status,
    };
    preferences.push(item);
  }

  state.preferences = [...preferences];
  return state;
};

export default function elementsReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPE.ENABLE_ITEM_INIT: {
      const { elementType, elementId } = payload;
      return changeItemStatus(elementType, elementId, 1, state);
    }
    case ACTION_TYPE.ENABLE_ITEM_FAILURE: {
      const { elementType, elementId } = payload;
      return changeItemStatus(elementType, elementId, 0, state);
    }
    case ACTION_TYPE.DISABLE_ITEM_INIT: {
      const { elementType, elementId } = payload;
      return changeItemStatus(elementType, elementId, 0, state);
    }
    case ACTION_TYPE.DISABLE_ITEM_FAILURE: {
      const { elementType, elementId } = payload;
      return changeItemStatus(elementType, elementId, 1, state);
    }
    case ACTION_TYPE.GET_PREFERENCES_SUCCESS: {
      return {
        ...state,
        preferences: [...payload],
      };
    }
    case ACTION_TYPE.SET_ACTION_IN_CONTEXT:
      return {
        ...state,
        actionInContext: payload.action,
        actionInContextPriority: payload.priority,
      };
    case ACTION_TYPE.PUSH_ELEMENT_IN_HISTORY: {
      const history = [...state.history];
      history.push(payload);
      return {
        ...state,
        history,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/serendipity/index.js